import React from "react";

import Logo from "../../Assets/Logo/logowhite.svg";

export default function Footer() {
  return (
    <footer className="bg-[#071B34] text-white">
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10">
        <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center">
          {/* Brand */}
          <div className="flex flex-col items-start">
            <img
              src={Logo}
              alt="Viktorindo Teknologi Prima"
              className="h-20 w-auto object-contain sm:h-24"
            />

            <div className="mt-4 h-1 w-16 rounded-full bg-[#2392D0]" />
          </div>

          {/* Company information */}
          <div className="flex flex-col gap-5">
            <p className="max-w-3xl text-sm leading-6 text-slate-200">
              We are an enterprise IT service partner providing integrated
              information technology solutions to support our clients&apos;
              business growth, security, and operational needs.
            </p>

            <div className="grid gap-5 sm:grid-cols-[1fr_auto] sm:items-end">
              <div className="space-y-2 text-sm text-slate-300">
                <p className="leading-6">
                  Grand Orchard Square Blok D No 10, Summarecon Kelapa Gading, Jl. Terusan Kelapa Hybrida, Sukapura, Cilincing, Jakarta Utara, 14140
                </p>

                <div className="flex flex-col gap-1 sm:flex-row sm:gap-5">
                  <a
                    href="mailto:support@viktorindo.co.id"
                    className="transition hover:text-white"
                  >
                    support@viktorindo.co.id
                  </a>

                  <a
                    href="tel:+6282122512660"
                    className="transition hover:text-white"
                  >
                    (+62) 821-2251-2660
                  </a>
                </div>
              </div>

              {/* Social media */}
              <div className="flex items-center gap-2.5">
                <a
                  href="https://www.linkedin.com/company/pt.-viktorindo-teknologi-prima/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white transition duration-300 hover:-translate-y-0.5 hover:border-[#2392D0] hover:bg-[#2392D0]"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-4 w-4"
                    aria-hidden="true"
                  >
                    <path d="M6.94 8.5H3.56V19h3.38V8.5ZM5.25 3A1.96 1.96 0 1 0 5.25 6.92 1.96 1.96 0 0 0 5.25 3ZM20.44 12.98c0-3.16-1.69-4.63-3.94-4.63-1.82 0-2.63 1-3.08 1.7V8.5h-3.38V19h3.38v-5.2c0-1.37.26-2.7 1.96-2.7 1.68 0 1.7 1.57 1.7 2.79V19h3.38l-.02-6.02Z" />
                  </svg>
                </a>

                <a
                  href="https://www.instagram.com/viktorindoteknologiprima/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white transition duration-300 hover:-translate-y-0.5 hover:border-[#2392D0] hover:bg-[#2392D0]"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    className="h-4 w-4"
                    aria-hidden="true"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="5"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="4"
                      stroke="currentColor"
                      strokeWidth="1.8"
                    />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-1 px-6 py-3 text-center text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between sm:text-left lg:px-10">
          <p>
            © {new Date().getFullYear()} PT Viktorindo Teknologi Prima | All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}